import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Image} from 'react-bootstrap'
import config from '../../config'
import {infoStatus} from '../../core/redux/status'
import DashboardPanel from '../../core/components/DashboardPanel'
import DashboardPanelAdd from '../../core/components/DashboardPanelAdd'
import AuditScoreDashboardPanel from '../../audit/components/ScoreDashboardPanel'
import i18n from '../i18n'
import style from './BuildingDashboard.less'

class BuildingDashboard extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, building} = this.props

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        return (
            <div>
                <Row>
                    <Col sm={6} md={4}>
                        <DashboardPanel light
                            header={panelHeader(i18n.description)}>
                            <ul className={style.data}>
                                <li>
                                    <label>> {i18n.addressCount} :</label>
                                    <span> {building.addresses.length}</span>
                                </li>
                            </ul>
                        </DashboardPanel>
                    </Col>
                    <Col sm={6} md={4}>
                        <DashboardPanelAdd 
                            onClick={() => dispatch(infoStatus(i18n.featureNotImplemented))} />
                    </Col>
                    {config.feature.audit && (
                        <Col sm={6} md={4}>
                            <DashboardPanel light
                                header={panelHeader(i18n.lastAudits)} />
                        </Col>
                    )}
                    {config.feature.audit && (
                        <Col sm={12} md={8}>
                            <AuditScoreDashboardPanel light />
                        </Col>
                    )}
                </Row>
            </div>
        )
    }
}

BuildingDashboard = connect((state) => ({
    building: state.patrimony.building.building
}))(BuildingDashboard)

export default BuildingDashboard


// WEBPACK FOOTER //
// ./lib/patrimony/components/BuildingDashboard.js